/* eslint-disable react/no-direct-mutation-state */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from '../../utils/obj-utils';
import initialState from '../helpers/form-helpers/initial-state';
import './ballot-sign-in-form.scss';
import { apiConstants } from '../../../store/api/api-constants';
import { ssoFormTypes } from '../../utils/form-types';
import RegisterFormBanner from '../one-club-register/RegisterFormBanner';
import { formConstants } from '../../utils/constants/form-constants';
import { getModalContentClassListForSSOForm, toggleBemClassesForSSOFormModal } from '../helpers/form-helpers/form-modal-helpers';
import { hasValue } from '../../../../../general/js/general-helpers';
import { getPageUrlWithoutQueryParams } from '../../../../../general/js/utils';
import Oauth from '../../oauth';

class BallotSignInForm extends Component {
    constructor(props) {
        super(props);
        const formData = this.loadFormData();

        this.state = {
            ...initialState.signInFormState,
            formData,
            isModalStylingUpdated: false
        };

        this.formReference = React.createRef();

        this.displayForm = this.displayForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleOauthSignUp = this.handleOauthSignUp.bind(this);
        this.preventFormSubmit = this.preventFormSubmit.bind(this);
        this.handleOauthSignIn = this.handleOauthSignIn.bind(this);
    }

    loadFormData() {
        const { formData } = this.props;

        if (!isEmpty(formData)) {
            sessionStorage.setItem(formConstants.ballotSignInStorageItem, JSON.stringify(formData));
            return formData;
        }

        return JSON.parse(sessionStorage.getItem(formConstants.ballotSignInStorageItem)) || null;
    }

    componentDidMount() {
        this.state.isModalStylingUpdated = toggleBemClassesForSSOFormModal(this.formReference, this.props, ssoFormTypes.BallotSignInForm);
    }

    componentWillReceiveProps(nextProps) {
        const { formData } = nextProps;

        if (hasValue(formData) && !this.state.isModalStylingUpdated) {
            this.state.isModalStylingUpdated = toggleBemClassesForSSOFormModal(this.formReference, nextProps, ssoFormTypes.BallotSignInForm);
        }
    }

    getFooterLink(linkCallBackUrl, footerLinkText) {
        if (!linkCallBackUrl ||
            isEmpty(footerLinkText)) {
            return null;
        }

        const { isBallotFlow } = this.props;
        const hrefAttribute = isBallotFlow ? { href: '#' } : null;

        return (<a className='link form__sign-in-link' {...hrefAttribute} onClick={linkCallBackUrl}
        >
            {footerLinkText}
        </a>);
    }

    getHeaderLink(linkCallBackUrl, headerLinkText) {
        if (!linkCallBackUrl || isEmpty(headerLinkText)) {
            return null;
        }

        return (<a
            className='link'
            href='#'
            data-dc-component='modal-trigger-login'
            onClick={linkCallBackUrl}>
            {headerLinkText}
        </a>
        );
    }

    handleSubmit() {
        const { formData, onSignIn } = this.props;

        const componentToRenderUrl = this.getComponentToRenderAfterSignIn(formData.nextFormTypeAfterSignIn);

        const url = getPageUrlWithoutQueryParams();

        const returnUrl = `${url}${componentToRenderUrl}`;

        onSignIn(returnUrl);
    }

    handleOauthSignUp() {
        const { formData: { oAuthRegisterRoute } } = this.props;

        Oauth.signUp(oAuthRegisterRoute);
    }

    handleOauthSignIn() {
        Oauth.federatedSignIn();
    }

    getComponentToRenderAfterSignIn(nextFormTypeToDisplay) {
        if (nextFormTypeToDisplay === ssoFormTypes.BallotSignInSuccessForm) {
            return apiConstants.ballotSignInSuccessFormDataUrl;
        }

        //Full register flow
        return apiConstants.ballotSummaryFormDataUrl;
    }

    preventFormSubmit(event) {
        event.preventDefault();
    }

    getHeadingText(headingText) {
        if (isEmpty(headingText)) { return null; }
        return <h3 className="title">{headingText}</h3>;
    }

    displayForm() {
        const { formData } = this.state;

        return (<Fragment>
            <form onSubmit={this.preventFormSubmit}>
                {this.getHeadingText(formData.headingText)}
                <div className='form__sign-in form__sign-in-ballot g-row'>
                    <div className='g-col-sm-6'>
                        <div>
                            &nbsp;
                        </div>
                        <div className='mt-xs highlight-button'>
                            {this.getButton(this.handleOauthSignIn, formData.signInButtonText)}
                        </div>
                        <div className='mt-xs'>
                            {this.getFooterLink(Oauth.forgotPassword, formData.forgottenPasswordLinkText)}
                        </div>
                    </div>
                    <div className='g-col-sm-6'>
                        <div className='form__sign-in-link'>
                            {formData.registerHeadingText}
                        </div>
                        <div className='mt-xs register-button'>
                            {this.getButton(this.handleOauthSignUp, formData.registerButtonText)}
                        </div>
                    </div>
                </div>
            </form>
        </Fragment>);
    }

    getButton(submitAction, buttonText) {
        return <button
            className='button button--primary'
            type='submit'
            data-dc-form-sso-ref='submit-button'
            onClick={submitAction}
        >
            {this.getButtonContent(buttonText)}
        </button>;
    }

    getButtonContent(buttonText) {
        return <span className='button-content button-content--icon'>
            <span>{buttonText}</span>
            <svg
                className='icon button__arrow-right'
                width='14'
                height='12'
                focusable='false'
            >
                <use xlinkHref='#icon-arrow-right'></use>
            </svg>
        </span>;
    }

    render() {
        const { formData } = this.state;
        const { formBanner } = formData;

        return (
            <div ref={this.formReference} className={getModalContentClassListForSSOForm(this.props)}>
                <RegisterFormBanner
                    formBanner={formBanner}
                ></RegisterFormBanner>
                <div className='auto-ph-md auto-p-md constrain-tablet ff-founders fs-14'>
                    {this.displayForm()}
                </div>
            </div>
        );
    }
}

BallotSignInForm.propTypes = {
    onSignIn: PropTypes.func.isRequired,
    onRegister: PropTypes.func.isRequired,
    onForgotPassword: PropTypes.func.isRequired
};

export default BallotSignInForm;
